import React, { useEffect } from "react";
import { useRouter } from "next/router";

const RedirectQuery = (): any => {
  const router = useRouter();
  useEffect(() => {
    router.push(`/sell-your-bag`, `/sell-your-bag/consignment`);
  }, []);
  return null;
};

const SellYourBagConsignment = (): React.ReactElement => (
  <div>
    <RedirectQuery />
  </div>
);

export default SellYourBagConsignment;
